import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { arrayOf, func, oneOf, string } from 'prop-types';
import { Button } from "../../../Button";
import { currencyCodes } from "../../../CurrencySelect";
import HeaderPopup from "../../../HeaderPopup";
import MenuLinks from "../../../MenuLinks";
import Popover, { alignmentsArray } from "../../../Popover";
import Title from "../../../Title";
import { Cn, Cny, De, En, Es, Eur, Hu, It, Ja, Ko, Ru, Rub, Usd, World } from "../../../icons";
import styles from './RegionSelect.css';
var cx = classNames.bind(styles);
var langs = [{
  choose: 'Готово',
  titleChoose: 'Выберите язык',
  titleCurrency: 'Выберите валюту',
  locale: 'ru',
  title: 'Русский',
  flag: /*#__PURE__*/React.createElement(Ru, {
    size: "md"
  })
}, {
  choose: '完成了',
  titleChoose: '选择语言',
  titleCurrency: '选择货币',
  locale: 'zh',
  title: '中文',
  flag: /*#__PURE__*/React.createElement(Cn, {
    size: "md"
  })
}, {
  choose: 'Done',
  titleChoose: 'Choose language',
  titleCurrency: 'Choose currency',
  locale: 'en',
  title: 'English',
  flag: /*#__PURE__*/React.createElement(En, {
    size: "md"
  })
}, {
  choose: 'Fatto',
  titleChoose: 'Scegli la lingua',
  titleCurrency: 'Scegli la valuta',
  locale: 'it',
  title: 'Italiano',
  flag: /*#__PURE__*/React.createElement(It, {
    size: "md"
  })
}, {
  choose: 'Getan',
  titleChoose: 'Sprache wählen',
  titleCurrency: 'Währung wählen',
  locale: 'de',
  title: 'Deutsch',
  flag: /*#__PURE__*/React.createElement(De, {
    size: "md"
  })
}, {
  choose: 'Hecho',
  titleChoose: 'idioma',
  titleCurrency: 'moneda',
  locale: 'es',
  title: 'Español',
  flag: /*#__PURE__*/React.createElement(Es, {
    size: "md"
  })
}, {
  choose: 'Done',
  titleChoose: 'Choose language',
  titleCurrency: 'Choose currency',
  locale: 'ja',
  title: '日本語',
  flag: /*#__PURE__*/React.createElement(Ja, {
    size: "md"
  })
}, {
  choose: 'Done',
  titleChoose: 'Choose language',
  titleCurrency: 'Choose currency',
  locale: 'ko',
  title: '한국어',
  flag: /*#__PURE__*/React.createElement(Ko, {
    size: "md"
  })
}, {
  choose: 'Done',
  titleChoose: 'Choose language',
  titleCurrency: 'Choose currency',
  locale: 'hu',
  title: 'Magyar',
  flag: /*#__PURE__*/React.createElement(Hu, {
    size: "md"
  })
}];
var currens = [{
  label: {
    ru: 'Рубль',
    en: 'Ruble',
    zh: '卢布',
    it: 'Rublo',
    de: 'Rubel',
    es: 'Rublo'
  },
  icon: /*#__PURE__*/React.createElement(Rub, {
    size: "md"
  }),
  code: 'RUB'
}, {
  label: {
    ru: 'Евро',
    en: 'Euro',
    zh: '欧元',
    it: 'Euro',
    de: 'Euro',
    es: 'Euro'
  },
  icon: /*#__PURE__*/React.createElement(Eur, {
    size: "md"
  }),
  code: 'EUR'
}, {
  label: {
    ru: 'Доллар',
    en: 'Dollar',
    zh: '美元',
    it: 'Dollaro',
    de: 'Dollar',
    es: 'Dólar'
  },
  icon: /*#__PURE__*/React.createElement(Usd, {
    size: "md"
  }),
  code: 'USD'
}, {
  label: {
    ru: 'Юань',
    en: 'Yuan',
    zh: '元',
    it: 'Yuan',
    de: 'Yuan',
    es: 'Yuan'
  },
  icon: /*#__PURE__*/React.createElement(Cny, {
    size: "md"
  }),
  code: 'CNY'
}];

var getSelected = function getSelected(lang, options) {
  return options.find(function (item) {
    return item.locale === lang;
  }) || options[0];
};

export var RegionSelect = function RegionSelect(props) {
  var align = props.align,
      dataQaButton = props.dataQaButton,
      dataQaPopup = props.dataQaPopup,
      language = props.language,
      languages = props.languages,
      currency = props.currency,
      currencies = props.currencies,
      onChange = props.onChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _getSelected = getSelected(language, langs),
      titleChoose = _getSelected.titleChoose,
      titleCurrency = _getSelected.titleCurrency,
      choose = _getSelected.choose;

  var _useState3 = useState(language),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedLanguage = _useState4[0],
      setSelectedLanguage = _useState4[1];

  var _useState5 = useState(currency),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedCurrency = _useState6[0],
      setSelectedCurrency = _useState6[1];

  var linksLang = langs.filter(function (_ref) {
    var locale = _ref.locale;
    return languages.includes(locale);
  }).map(function (item) {
    return {
      key: item.locale,
      active: selectedLanguage === item.locale,
      children: /*#__PURE__*/React.createElement(React.Fragment, null, item.flag, item.title),
      onClick: function onClick() {
        setSelectedLanguage(item.locale);
      }
    };
  });
  var linksCurrency = currens.filter(function (item) {
    return currencies.includes(item.code);
  }).map(function (item) {
    return {
      key: item.code,
      active: selectedCurrency === item.code,
      children: /*#__PURE__*/React.createElement(React.Fragment, null, item.icon, item.label[selectedLanguage], "\xA0", /*#__PURE__*/React.createElement("span", {
        className: cx('code')
      }, item.code)),
      onClick: function onClick() {
        setSelectedCurrency(item.code);
      }
    };
  });
  var toggler = /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('button'),
    "data-qa": dataQaButton
  }, /*#__PURE__*/React.createElement(World, null)));

  var handleChoose = function handleChoose() {
    onChange({
      language: selectedLanguage,
      currency: selectedCurrency
    });
    setIsOpen(false);
  };

  return /*#__PURE__*/React.createElement(Popover, {
    align: align,
    toggler: toggler,
    isOpen: isOpen,
    onToggle: setIsOpen,
    isMobileFixed: true
  }, /*#__PURE__*/React.createElement(HeaderPopup, {
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('popup'),
    "data-qa": dataQaPopup
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('title')
  }, /*#__PURE__*/React.createElement(Title, {
    level: 4,
    as: "p",
    ellipsis: true
  }, titleChoose)), /*#__PURE__*/React.createElement(MenuLinks, {
    links: linksLang,
    columns: true
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('title')
  }, /*#__PURE__*/React.createElement(Title, {
    level: 4,
    as: "p",
    ellipsis: true
  }, titleCurrency)), /*#__PURE__*/React.createElement(MenuLinks, {
    links: linksCurrency,
    columns: true
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('choose')
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "outline",
    onClick: handleChoose,
    block: true
  }, choose)))));
};
export var languages = langs.map(function (item) {
  return item.locale;
});
export var currencies = currens.map(function (item) {
  return item.code;
});
RegionSelect.propTypes = process.env.NODE_ENV !== "production" ? {
  align: oneOf(alignmentsArray),
  currency: oneOf(currencies),
  currencies: arrayOf(oneOf(currencyCodes)),
  dataQaButton: string,
  dataQaPopup: string,
  language: oneOf(languages),
  languages: arrayOf(oneOf(languages)),
  onChange: func.isRequired
} : {};
RegionSelect.defaultProps = {
  currency: currencies[0],
  dataQaButton: 'language_selector',
  dataQaPopup: 'language_block',
  language: languages[0],
  languages: languages
};